import React, { useContext, useState } from "react";
import Back from "../../assets/back.svg";
import FileIcon from "../../assets/fileIcon.svg";
import CancelIcon from "../../assets/Cancel.svg";
import { Link, useNavigate } from "react-router-dom";
import { getAudioSummarize } from "../../utils/services/api";
import { AppContext } from "../../utils/Context/AppContext";

// import Loader from "../../components/Loader/Loader";

const UploadAudio = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const { dispatch } = useContext(AppContext);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState("");
  const [isProceedStart, setIsProceedStart] = useState(false);
  const [isDragging, setIsDragging] = useState(false); // ⭐ New state for drag-over visual

  const navigate = useNavigate();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFile(file);
      const baseName = file.name.split(".").slice(0, -1).join(".");
      setSelectedFile({ name: baseName, size: file.size });
      setFileName(baseName);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const file = event.dataTransfer.files[0];
    if (file && file.type.startsWith("audio/")) {
      setFile(file);
      const baseName = file.name.split(".").slice(0, -1).join(".");
      setSelectedFile({ name: baseName, size: file.size });
      setFileName(baseName);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDragEnter = () => {
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleCancel = () => {
    setSelectedFile(null);
    setFileName("");
    document.getElementById("uploadFile1").value = "";
  };

  const handleProceed = async () => {
    try {
  
      if (!file || !fileName) throw new Error("File or fileName is missing");
      
      let form = new FormData();
      form.append("file", file);
      form.append("file_name", fileName);

      setIsProceedStart(true);
      let proceedFile = await getAudioSummarize(form);

      if (proceedFile) {
        dispatch({ type: "SET_AUDIO_FILE", payload: file });
        dispatch({
          type: "SET_AUDIO_FILE_SUMMARY",
          payload: proceedFile.summary,
        });
        dispatch({ type: "AUDIO_FILE_NAME", payload: proceedFile.file_name });
        navigate("/audio-summarized");
        setIsProceedStart(false);
      }
    } catch (error) {
      console.log("error while process the file ...", error);
      setIsProceedStart(false);
    }
  };

  return !isProceedStart ? (
    <>
      <div className="flex flex-col bg-slate-100 w-full px-4">
        <div className="flex gap-2 py-2  w-full">
          <Link to="/main" className="flex gap-2">
            <img src={Back} alt="Back" className="w-7 h-auto" />
            <span className="text-[#242424] ">Back</span>
          </Link>
        </div>
        <div className="w-full flex justify-center">
          <div className="flex flex-col justify-center items-center gap-6 h-[25rem] w-[47.63rem] bg-white rounded-lg p-2 pl-4 pr-4">
            <div className="w-full">
              <label
                htmlFor="uploadFile1"
                className={`bg-[#f8fdff] text-base rounded h-40 flex flex-col items-center justify-center cursor-pointer border-2 ${
                  selectedFile ? "border-[#B6EBFF]" : "border-dashed"
                } ${
                  isDragging ? "border-[#2A67C3] bg-blue-50" : ""
                } mx-auto font-sans`}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-11 mb-2 fill-[#2A67C3]"
                  viewBox="0 0 32 32"
                >
                  <path d="M23.75 11.044a7.99 7.99 0 0 0-15.5-.009A8 8 0 0 0 9 27h3a1 1 0 0 0 0-2H9a6 6 0 0 1-.035-12 1.038 1.038 0 0 0 1.1-.854 5.991 5.991 0 0 1 11.862 0A1.08 1.08 0 0 0 23 13a6 6 0 0 1 0 12h-3a1 1 0 0 0 0 2h3a8 8 0 0 0 .75-15.956z" />
                  <path d="M20.293 19.707a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 1.414 1.414L15 16.414V29a1 1 0 0 0 2 0V16.414z" />
                </svg>
                <span className="font-custom text-sm font-normal text-[#242424]">
                  Drop your Audio here, or{" "}
                  <span className="font-custom text-sm font-normal text-[#2A67C3]">
                    browse
                  </span>
                </span>
                <input
                  type="file"
                  id="uploadFile1"
                  className="hidden"
                  accept="audio/*"
                  onChange={handleFileChange}
                />
                <p className="text-xs font-medium text-[#616161]">
                  Supports: mp3
                </p>
              </label>
            </div>

            {selectedFile ? (
              <div className="flex items-center justify-between w-full p-2 shadow-[0px_1px_5.3px_0px_#00000021] rounded-md">
                <div className="flex-shrink-0">
                  <img src={FileIcon} alt="file icon" />
                </div>
                <div className="flex flex-col flex-grow mx-2">
                  <span className="text-sm font-bold text-[#242424]">
                    {fileName}
                  </span>
                  <span className="text-sm font-medium text-[#616161]">
                    {(selectedFile.size / (1024 * 1024)).toFixed(2)} MB
                  </span>
                </div>
                <div className="flex-shrink-0">
                  <img
                    src={CancelIcon}
                    alt="CancelIcon"
                    className="w-6 h-6 cursor-pointer"
                    onClick={handleCancel}
                  />
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center w-full p-4 text-gray-500">
                <span>No file selected</span>
              </div>
            )}
            <div className="flex flex-row w-full justify-between gap-3 pb-2">
              <button
                className={`text-center w-full ${
                  selectedFile
                    ? "text-[#01AEEF] border border-[#01AEEF]"
                    : "text-gray-400 border-gray-400"
                } rounded-[40px] py-2`}
                disabled={!selectedFile}
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="text-center w-full bg-[#01AEEF] text-white rounded-[40px] py-2"
                disabled={!selectedFile}
                onClick={handleProceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    // No changes to this block — Spinner stays the same
    <>
      <div className="flex flex-col bg-slate-100 w-full px-4">
        <div className="flex gap-2 py-2 w-full">
          <Link to="/main" className="flex gap-2">
            <img src={Back} alt="Back" className="w-8 h-8" />
            <span className="text-[#242424] pt-[0.14rem]">Back</span>
          </Link>
        </div>
        <div className="flex flex-col justify-center items-center gap-2 h-full w-full bg-white rounded-lg ">
          {/* <div role="status">
            <svg
              ariaHidden="true"
              className="w-[57px] h-[57px] text-gray-200 animate-spin dark:text-gray-600 fill-[#146AAB]"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591..."
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038..."
                fill="currentFill"
              />
            </svg>
          </div> */}
          <span className="loader"></span>
          <div className=" text-custom-size font-custom-weight leading-custom-line text-center">
            Almost there!
          </div>
          <div className="text-[#A4A4A4] text-sm text-base font-normal leading-tight text-center">
            We're processing your audio to deliver Summary in just a moment!
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadAudio;
